import { API_ROOT } from '../../config/config'

import { doGet, doPost, doPostFiles, doDownload } from './utils'

export const getCancelForm = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/cancelled`
  return doGet(url)
}

export const updateCancel = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/cancelled`
  return doPostFiles(url, request)
}

export const getDownloadFileCancel = (projectVersionId, fileId, fileType) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/cancelled/${fileId}/${fileType}`
  return doDownload(url)
}

export const getDownloadFileCancelNew = (filePath) => {
    const url = `${API_ROOT}/progress/file-download?filePath=${filePath}`
    return doDownload(url)
  }
